import { LANDING_CURVE_DISPLACEMENT_SCALE, LANDING_ENDCAP_ZOOM, LINE_SPACING, MATCHED_IDLE_SPEED, PAPER, STANDARD_END } from "./shared";
/**
 * The horizontal hand-off every composition may end with: the ribbon fades in
 * its current shape, turns horizontal, reveals from both viewport edges over
 * 2.5 s and releases with the closing block so the footer covers it. Authored
 * for the landing page (prototype `horizontal-endcap`); straight, so it works
 * with any opening's curve profile.
 */
const LANDING_HORIZONTAL_ENDCAP_VALUES = {
    background: PAPER,
    zoom: LANDING_ENDCAP_ZOOM,
    center: [0.5, 0.5],
    rotationDeg: -180.972,
    lineExtent: 1.312,
    turbulence: 0.37,
    spacing: LINE_SPACING,
    speed: MATCHED_IDLE_SPEED,
    dither: 0,
    spatialColor: 0.18,
    twistRetention: 1,
    fanSpread: 0,
    twistSpread: 0,
    horizontalStretch: 1,
    unravel: 0,
    curveStrength: 0,
    curveDisplacementScale: LANDING_CURVE_DISPLACEMENT_SCALE,
    curveProgress: 1,
};
export const HORIZONTAL_ENDCAP_STATES = [
    {
        id: "horizontal-endcap-hidden",
        ...LANDING_HORIZONTAL_ENDCAP_VALUES,
        effectOpacity: 0,
        edgeReveal: 0,
    },
    {
        id: "horizontal-endcap",
        ...LANDING_HORIZONTAL_ENDCAP_VALUES,
        effectOpacity: 1,
        edgeReveal: 1,
    },
];
/** The three endcap steps; `hiddenStateId` is the faded copy of the shape the visitor is looking at. */
export function endcapSteps(hiddenStateId) {
    return [
        {
            role: "endcap",
            stateId: hiddenStateId,
            start: { target: "top", viewport: 1 },
            end: { target: "top", viewport: 0.5 },
        },
        {
            role: "endcap",
            stateId: "horizontal-endcap-hidden",
            start: { target: "top", viewport: 0.5 },
            end: { target: "top", viewport: 0.5 },
        },
        {
            role: "endcap",
            stateId: "horizontal-endcap",
            start: { target: "top", viewport: 0.5 },
            end: { target: "top", viewport: 0.15 },
            release: { target: "top", viewport: 0.5 },
            releaseTop: STANDARD_END,
            timedRevealDurationMs: 2500,
            timedRevealReverseStart: { target: "top", viewport: 0.35 },
            timedRevealReverseScrollBound: true,
        },
    ];
}
//# sourceMappingURL=endcap.js.map